export default "__VITE_ASSET__iBvWP02y__"